"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAR;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
function getAR(_ref) {
  var packages = _ref.packages;
  var faceLandmarksDetection = packages.faceLandmarksDetection;
  if (!faceLandmarksDetection) {
    return null;
  }
  return /*#__PURE__*/function () {
    function AR(_ref2) {
      var container = _ref2.container,
        _ref2$shouldFaceUser = _ref2.shouldFaceUser,
        shouldFaceUser = _ref2$shouldFaceUser === void 0 ? true : _ref2$shouldFaceUser,
        onUpdate = _ref2.onUpdate,
        onProgress = _ref2.onProgress,
        onError = _ref2.onError;
      (0, _classCallCheck2["default"])(this, AR);
      this.container = container;
      this.shouldFaceUser = shouldFaceUser;
      this.onUpdate = onUpdate;
      this.video = null;
      this.controller = null;
      this.playState = -1;
      this.detector = null;
      this.animationID = null;
      this.width = 0;
      this.height = 0;
      this.offsetWidth = 0;
      this.offsetHeight = 0;
      this.scale = 1;
      this.mask = null;
      this.progress = null;
      this.onProgress = onProgress;
      this.onError = onError;
      this._createElements();
    }
    (0, _createClass2["default"])(AR, [{
      key: "start",
      value: function () {
        var _start = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5() {
          var _this = this;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.controller) {
                  this.controller = {
                    onUpdate: function () {
                      var _onUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(p) {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                          while (1) switch (_context.prev = _context.next) {
                            case 0:
                              if (!_this.onUpdate) {
                                _context.next = 3;
                                break;
                              }
                              _context.next = 3;
                              return _this.onUpdate((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
                                width: _this.width,
                                height: _this.height,
                                offsetWidth: _this.offsetWidth,
                                offsetHeight: _this.offsetHeight,
                                faceLandmarksDetection: faceLandmarksDetection
                              }));
                            case 3:
                            case "end":
                              return _context.stop();
                          }
                        }, _callee);
                      }));
                      function onUpdate(_x) {
                        return _onUpdate.apply(this, arguments);
                      }
                      return onUpdate;
                    }(),
                    detectFace: function () {
                      var _detectFace = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(source) {
                        var faces;
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                          while (1) switch (_context2.prev = _context2.next) {
                            case 0:
                              if (!_this.detector) {
                                _context2.next = 18;
                                break;
                              }
                              faces = [];
                              _context2.prev = 2;
                              _context2.next = 5;
                              return _this.detector.estimateFaces(source, {/*flipHorizontal: true*/});
                            case 5:
                              faces = _context2.sent;
                              _context2.next = 15;
                              break;
                            case 8:
                              _context2.prev = 8;
                              _context2.t0 = _context2["catch"](2);
                              _this.detector.dispose();
                              _this.detector = null;
                              _this.stop();
                              console.log("[APP]", "AR:", "Face detection error", _context2.t0);
                              if (_this.onError) {
                                _this.onError((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _context2.t0), {}, {
                                  message: "Face detection error"
                                }));
                              }
                            case 15:
                              if (!(faces && faces[0])) {
                                _context2.next = 18;
                                break;
                              }
                              faces.forEach(function (face) {
                                var keypoints = face.keypoints || [];
                                keypoints.forEach(function (point) {
                                  point.x = point.x * _this.scale;
                                  point.y = point.y * _this.scale;
                                  point.z = point.z * _this.scale;
                                });
                              });
                              return _context2.abrupt("return", faces);
                            case 18:
                              return _context2.abrupt("return", []);
                            case 19:
                            case "end":
                              return _context2.stop();
                          }
                        }, _callee2, null, [[2, 8]]);
                      }));
                      function detectFace(_x2) {
                        return _detectFace.apply(this, arguments);
                      }
                      return detectFace;
                    }(),
                    setup: function () {
                      var _setup = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
                        var assetsToRelative, res, json;
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                          while (1) switch (_context3.prev = _context3.next) {
                            case 0:
                              if (!(faceLandmarksDetection && !_this.detector)) {
                                _context3.next = 18;
                                break;
                              }
                              assetsToRelative = false;
                              _context3.prev = 2;
                              _context3.next = 5;
                              return fetch("./assets/tensorflow/landmark/model.json");
                            case 5:
                              res = _context3.sent;
                              _context3.next = 8;
                              return res.json();
                            case 8:
                              json = _context3.sent;
                              if (res.status === 200 && json) {
                                assetsToRelative = true;
                              }
                              _context3.next = 14;
                              break;
                            case 12:
                              _context3.prev = 12;
                              _context3.t0 = _context3["catch"](2);
                            case 14:
                              console.log("[APP]", "AR:", "Assets relative:", assetsToRelative);
                              _context3.next = 17;
                              return faceLandmarksDetection.createDetector(faceLandmarksDetection.SupportedModels.MediaPipeFaceMesh, {
                                runtime: "tfjs",
                                maxFaces: 1,
                                //solutionPath: (assetsToRelative) ? './assets/tensorflow/face_mesh' : '/assets/tensorflow/face_mesh',
                                //refineLandmarks: true,
                                detectorModelUrl: assetsToRelative ? './assets/tensorflow/face/model.json' : '/assets/tensorflow/face/model.json',
                                landmarkModelUrl: assetsToRelative ? './assets/tensorflow/landmark/model.json' : '/assets/tensorflow/landmark/model.json'
                              });
                            case 17:
                              _this.detector = _context3.sent;
                            case 18:
                            case "end":
                              return _context3.stop();
                          }
                        }, _callee3, null, [[2, 12]]);
                      }));
                      function setup() {
                        return _setup.apply(this, arguments);
                      }
                      return setup;
                    }(),
                    processVideo: function processVideo(video) {
                      if (_this.animationID) {
                        cancelAnimationFrame(_this.animationID);
                      }
                      if (!_this.detector) {
                        return;
                      }
                      var updateOnce = false;
                      var render = /*#__PURE__*/function () {
                        var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4() {
                          var faces;
                          return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
                            while (1) switch (_context4.prev = _context4.next) {
                              case 0:
                                if (_this.animationID) {
                                  cancelAnimationFrame(_this.animationID);
                                  _this.animationID = null;
                                }
                                _context4.next = 3;
                                return _this.controller.detectFace(video);
                              case 3:
                                faces = _context4.sent;
                                if (!_this.controller.onUpdate) {
                                  _context4.next = 7;
                                  break;
                                }
                                _context4.next = 7;
                                return _this.controller.onUpdate({
                                  faces: faces
                                });
                              case 7:
                                if (!updateOnce) {
                                  _this._hideProgress();
                                  updateOnce = true;
                                }
                                if (_this.playState >= 1) {
                                  _this.animationID = requestAnimationFrame(function () {
                                    render();
                                  });
                                }
                              case 9:
                              case "end":
                                return _context4.stop();
                            }
                          }, _callee4);
                        }));
                        return function render() {
                          return _ref3.apply(this, arguments);
                        };
                      }();
                      console.log("[APP]", "AR:", "Start process video");
                      render();
                    },
                    stopProcessVideo: function stopProcessVideo() {
                      console.log("[APP]", "AR:", "Stop process video");
                      if (_this.animationID) {
                        cancelAnimationFrame(_this.animationID);
                        _this.animationID = null;
                      }
                    }
                  };
                }
                this.stop();
                console.log("[APP]", "AR:", "Loading...");
                this._showProgress({
                  message: "Waiting for camera access..."
                });
                _context5.prev = 4;
                _context5.next = 7;
                return this._startVideo();
              case 7:
                this._showProgress({
                  message: "Camera ready..."
                });
                _context5.prev = 8;
                _context5.next = 11;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 1000);
                });
              case 11:
                this._showProgress({
                  message: "Starting face landmarks detection..."
                });
                _context5.next = 14;
                return this._startAR();
              case 14:
                console.log("[APP]", "AR:", "Loading complete");
                _context5.next = 21;
                break;
              case 17:
                _context5.prev = 17;
                _context5.t0 = _context5["catch"](8);
                if (_context5.t0) {
                  if (this.onError) {
                    this.onError((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _context5.t0), {}, {
                      message: "Error when starting AR"
                    }));
                  }
                  console.log(_context5.t0);
                }
                this._hideProgress();
              case 21:
                _context5.next = 27;
                break;
              case 23:
                _context5.prev = 23;
                _context5.t1 = _context5["catch"](4);
                if (_context5.t1) {
                  if (this.onError) {
                    this.onError((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _context5.t1), {}, {
                      message: "Error when starting stream from media device"
                    }));
                  }
                  console.log(_context5.t1);
                }
                this._hideProgress();
              case 27:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this, [[4, 23], [8, 17]]);
        }));
        function start() {
          return _start.apply(this, arguments);
        }
        return start;
      }()
    }, {
      key: "stop",
      value: function stop() {
        if (this.playState >= 1) {
          this.controller.stopProcessVideo();
          if (this.video) {
            if (this.video.srcObject) {
              var tracks = this.video.srcObject.getTracks();
              tracks.forEach(function (track) {
                track.stop();
              });
            }
            this.video.remove();
          }
          this.playState = 0;
          this.video = null;
        }
      }
    }, {
      key: "toggle",
      value: function () {
        var _toggle = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6() {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                if (!this.video) {
                  _context6.next = 4;
                  break;
                }
                this.stop();
                _context6.next = 6;
                break;
              case 4:
                _context6.next = 6;
                return this.start();
              case 6:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
        function toggle() {
          return _toggle.apply(this, arguments);
        }
        return toggle;
      }()
    }, {
      key: "_createElements",
      value: function _createElements() {
        if (!this.mask) {
          this.mask = document.createElement('div');
          this.container.appendChild(this.mask);
        }
        if (!this.progress) {
          this.progress = document.createElement('div');
          this.container.appendChild(this.progress);
        }
      }
    }, {
      key: "_showProgress",
      value: function _showProgress() {
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$message = _ref4.message,
          message = _ref4$message === void 0 ? "" : _ref4$message;
        this.progress.style.visibility = "visible";
        if (this.onProgress) {
          this.onProgress(true, message);
        }
      }
    }, {
      key: "_hideProgress",
      value: function _hideProgress() {
        if (this.progress) {
          this.progress.style.visibility = "hidden";
        }
        if (this.onProgress) {
          this.onProgress(false, "");
        }
      }
    }, {
      key: "_startVideo",
      value: function _startVideo() {
        var _this2 = this;
        return new Promise(function (resolve, reject) {
          _this2.video = document.createElement('video');
          _this2.video.setAttribute('autoplay', '');
          _this2.video.setAttribute('muted', '');
          _this2.video.setAttribute('playsinline', '');
          _this2.mask.appendChild(_this2.video);
          if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            console.log("[APP]", "AR:", "Error", "There is not media device");
            if (_this2.onError) {
              _this2.onError({
                message: "There is not media device"
              });
            }
            reject();
            return;
          }
          navigator.mediaDevices.getUserMedia({
            audio: false,
            video: {
              facingMode: _this2.shouldFaceUser ? 'face' : 'environment'
            }
          }).then(function (stream) {
            _this2.video.addEventListener('loadedmetadata', function () {
              _this2.width = _this2.video.videoWidth;
              _this2.height = _this2.video.videoHeight;
              _this2.video.setAttribute('width', _this2.width);
              _this2.video.setAttribute('height', _this2.height);
              _this2.resize();
              resolve();
            });
            _this2.video.srcObject = stream;
            _this2.playState = 1;
          })["catch"](function (err) {
            console.log("[APP]", "AR:", "Error", "Media device error", err);
            if (_this2.onError) {
              _this2.onError({
                message: "Media device error"
              });
            }
            reject();
          });
        });
      }
    }, {
      key: "_startAR",
      value: function _startAR() {
        var _this3 = this;
        return new Promise( /*#__PURE__*/function () {
          var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7(resolve) {
            var video;
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  video = _this3.video;
                  _context7.next = 3;
                  return _this3.controller.setup(video);
                case 3:
                  _this3.controller.processVideo(video);
                  resolve();
                case 5:
                case "end":
                  return _context7.stop();
              }
            }, _callee7);
          }));
          return function (_x3) {
            return _ref5.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "resize",
      value: function resize() {
        if (this.container && this.video) {
          var parentElement = this.container;
          var parentHeight = parentElement === null || parentElement === void 0 ? void 0 : parentElement.offsetHeight;
          var scaleY = parentHeight / this.video.videoHeight;
          //const parentWidth = parentElement?.offsetWidth;
          //const scaleX = parentWidth / this.video.videoWidth;
          var max = scaleY;
          this.video.style.width = this.video.videoWidth * max + "px";
          this.video.style.height = this.video.videoHeight * max + "px";
          this.offsetWidth = this.video.videoWidth * max;
          this.offsetHeight = this.video.videoHeight * max;
          this.scale = max;
        }
      }
    }]);
    return AR;
  }();
}